module.exports = __webpack_public_path__ + "static/img/jiangnanchun.7d81571.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/jiangnanchun.png
// module id = Ae0F
// module chunks = 0